module.exports = __webpack_public_path__ + "static/media/06_environmental-sensing-module.062cc3d8.mp4";